var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"year-calendar"},_vm._l((12),function(m){return _c('calendar-month',{key:m,attrs:{"year":_vm.year,"month":m - 1,"variablePricingDates":_vm.variablePricingDates}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }